import '../../css/mk-brand.css';
import OliveOil from '../../media/olive-oil.png'

import {useState, useEffect} from "react";

function Panel() {
  useEffect(() => {}, );
  const statsAndUpgrades = "After levelling up, stats will be available for you to strengthen your characters ability. Players will have to choose whether to increase their - Vision - Execution or Synergy trees according to which culinary path they decide.";
  const mKBattleChefDetails = "Created with feedback of our mK Syndicate members. Our in game P2E characters will transition from Phase 1 Missions to mKBattle PvP game.";
  const missionsDetails = "Holders will have the chance to send their newly acquired metaChefs on missions that will award stats, experience points and upgrades. metaChefs will require at least one ingredient and one utensil to access the missions as they provide scrumptious bonus effects according to the type and rarity.";
  const P2ERewardsDetails = "Enjoy Play-2-Earn rewards when your mission tested chef wins big in metaKitchen battle. Build your team of ultimate chefs then test their skills in the metaKitchen";
  const defaultDetails = "metaChefs are the building blocks of our game. Created from different culinary backgrounds each limited release will feature a new metaChef archetype. metaChefs will be obtainable with $CHEF tokens or $SOL.";

    const updateMetaChefDetails = (details = null) => {
    if (details) {
        document.getElementById("mk-meta-chef-details").innerText = details;
    } else {
        document.getElementById("mk-meta-chef-details").innerText = defaultDetails;
    }
  };
  return (
      <div id="meta-chefs-panel" className="m-2">
          <div className="container bg-zinc-800 pt-4 px-4 pb-4 rounded-lg max-w-6xl">
              <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:items-center">
                  <div className="lg:col-start-1 lg:max-w-2xl ml-auto">
                      <div className="flex">
                      <h1 className=" text-4xl sm:text-6xl font-extrabold leading-none text-white">
                          meta
                      </h1>
                      <h1 className=" text-4xl sm:text-6xl font-extrabold leading-none text-brand">
                          Chef
                      </h1>
                        </div>
                      <h4 className="text-gray-400 font-bold md:text-2xl">
                          OUR ULTIMATE CHEF COLLECTION
                      </h4>
                      <p className="mt-2 h-48 md:h-16 lg:h-24" id="mk-meta-chef-details">metaChefs are the building
                          blocks of our game. Created from different culinary backgrounds each limited release will feature a new metaChef archetype.
                          metaChefs will be obtainable with $CHEF tokens or $SOL.
                      </p>
                      <ul className="mt-8 sm:items-center md:grid md:grid-cols-2 gap-6 md:gap-2">
                          <li className="mt-6 lg:mt-0">
                              <div className="py-1 px-2 rounded-lg text-white font-bold bg-brand hover:bg-zinc-400 hover:text-black text-center cursor-pointer"
                                   onMouseEnter={()=> updateMetaChefDetails(mKBattleChefDetails)}
                                   onMouseLeave={() => updateMetaChefDetails()}
                              >
                                  <span className="">mKBattle Chef</span>
                              </div>
                          </li>
                          <li className="mt-6 lg:mt-0">
                              <div className="py-1 px-2 rounded-lg text-white text-center font-bold bg-brand hover:bg-zinc-400 hover:text-black cursor-pointer"
                                   onMouseEnter={()=> updateMetaChefDetails(missionsDetails)}
                                   onMouseLeave={() => updateMetaChefDetails()}>
                                  <span
                                      className="">
                                Missions
                            </span>
                              </div>
                          </li>
                          <li className="mt-6 lg:mt-0">
                              <div className="py-1 px-2 rounded-lg text-white font-bold bg-brand hover:bg-zinc-400 hover:text-black text-center cursor-pointer"
                                   onMouseEnter={()=> updateMetaChefDetails(statsAndUpgrades)}
                                   onMouseLeave={() => updateMetaChefDetails()}>
                                  <span
                                      className="">
                                Stats & Upgrades
                            </span>
                              </div>
                          </li>
                          <li className="mt-6 lg:mt-0">
                              <div className="py-1 px-2 rounded-lg text-white font-bold bg-brand hover:bg-zinc-400 hover:text-black text-center cursor-pointer"
                                   onMouseEnter={()=> updateMetaChefDetails(P2ERewardsDetails)}
                                   onMouseLeave={() => updateMetaChefDetails()}>
                                  <span className="">P2E Rewards</span>
                              </div>
                          </li>
                      </ul>
                  </div>
                  <div className="h-4 lg:hidden" />
                  <div className="">
                      <div className="container">
                          <img className="mx-auto rounded-lg w-80 md:w-112"
                               src={OliveOil}
                               alt="metaChef pours Olive Oil"/>
                      </div>
                  </div>
              </div>
          </div>
          <div className="h-4" />
      </div>
  );
}

export default Panel;

